import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasDateDirective } from './gas-date.directive';

const DIRECTIVES = [
  GasDateDirective,
];

@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  exports: [
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasDateDirectiveModule  { }
